import React from "react";
import { Doughnut } from "react-chartjs-2";
import SectionCard from "../shared/SectionCard";
import "../shared/chartSetup";

/**
 * Sessions by Country card: donut chart with a center total value + colour legend below.
 *
 * @param {string}  [title="Sessions by Country"]
 * @param {object}  chartData           Chart.js doughnut data object
 * @param {number}  [total]             Number displayed in the doughnut center
 * @param {string}  [totalLabel="Total"] Label under the center number
 * @param {number}  [donutSize=140]     Width/height of the donut container in px
 */
const SessionsByCountry = ({
  title = "Sessions by Country",
  chartData,
  total,
  totalLabel = "Total",
  donutSize = 140,
}) => {
  const opts = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "68%",
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
  };

  const labels = chartData?.labels ?? [];
  const bgColors = chartData?.datasets?.[0]?.backgroundColor ?? [];

  return (
    <SectionCard title={title}>
      <div className="d-flex flex-column align-items-center">
        {/* Donut + center text */}
        <div
          style={{ position: "relative", height: donutSize, width: donutSize }}
        >
          <Doughnut
            data={chartData ?? { labels: [], datasets: [] }}
            options={opts}
          />
          {total !== undefined && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                pointerEvents: "none",
              }}
            >
              <div
                className="fw-bold"
                style={{ fontSize: "1.3rem", color: "#101828", lineHeight: 1 }}
              >
                {total.toLocaleString()}
              </div>
              <div style={{ fontSize: "0.65rem", color: "#667085" }}>
                {totalLabel}
              </div>
            </div>
          )}
        </div>

        {/* Colour legend */}
        <div className="d-flex gap-3 mt-2 flex-wrap justify-content-center">
          {labels.map((lbl, i) => (
            <div key={lbl} className="d-flex align-items-center gap-1">
              <div
                className="rounded-circle"
                style={{
                  width: 7,
                  height: 7,
                  background: bgColors[i] ?? "#ccc",
                }}
              />
              <span style={{ fontSize: "0.68rem", color: "#667085" }}>
                {lbl}
              </span>
            </div>
          ))}
        </div>
      </div>
    </SectionCard>
  );
};

export default SessionsByCountry;
